import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  ACTION_COL_CLASS,
  primaryCtaClassName,
  REGISTER_CARD_CLASS,
  RegisterBackButton,
  RegisterStepFooter,
} from './registerShared';

type RegisterStepSuccessProps = {
  onBack: () => void;
};

const RegisterStepSuccess: React.FC<RegisterStepSuccessProps> = ({ onBack }) => {
  const { t } = useTranslation('auth');

  return (
    <div className={REGISTER_CARD_CLASS}>
      <div>
        <RegisterBackButton onBack={onBack} />
        <h1 className="text-center text-[22px] font-semibold leading-tight text-gray-900">
          {t('register.success.title')}
        </h1>
      </div>

      <p className="text-center text-sm text-gray-600">{t('register.success.body')}</p>

      <div className={ACTION_COL_CLASS}>
        <Link
          to="/signin"
          className={`${primaryCtaClassName} flex items-center justify-center text-center no-underline`}
        >
          {t('register.success.sign_in')}
        </Link>
      </div>

      <RegisterStepFooter step={4} />
    </div>
  );
};

export default RegisterStepSuccess;
